(function () {
    'use strict';

    angular.module("imApp").factory("seasonalitiesService", ['$ihttp', function ($ihttp) {
        let service = {
            listSeasonalities: function (parms) {
                return $ihttp.post({
                    method: 853,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
